import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { generateMedismartScheduleRequestAction } from 'happ-redux/happ-actions/medismartSchedule/medismartScheduleAction';

const AppInitializaer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const hasRunGenerateSchedule = useRef(false);
    const token = localStorage.getItem('token');
    const { profile } = useSelector(state => state.auth);

    useEffect(() => {
        const fetchData = async () => {
            const body = {
                patientId: profile._id,
            }
            dispatch(generateMedismartScheduleRequestAction(body, navigate));
        };
        if (token && profile && !hasRunGenerateSchedule.current) {
            hasRunGenerateSchedule.current = true;
            fetchData();
        }
    }, [token, dispatch, navigate, profile]);

    return null;
}

export default AppInitializaer;